import { AfterViewInit, Component} from '@angular/core';
import { Router } from '@angular/router';

declare const $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements AfterViewInit {

  constructor(public router: Router) {

  }

  ngAfterViewInit() {
    $('.player').on('click', function(e) {
      $('video').get(0).play();
      $(this).hide();
    });
  }

  login() {
    this.router.navigate(['/login/inscription']);
  }

  myScrollHandler(event) {
    if (window.pageYOffset >= 80) {
      $('header').addClass('visible');
    } else {
      $('header').removeClass('visible');
    }
  }
}



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/components/home/home.component.ts